import { ROUTE_PATHS } from '@/constants';
import {
  BookOpen,
  Building,
  Calendar,
  FileText,
  GraduationCap,
  LayoutDashboard,
  List,
  Mountain,
  Truck,
  User,
  User2,
  Users,
  UtensilsCrossed,
  Wrench
} from 'lucide-react';
import { ForwardRefExoticComponent } from 'react';

export interface NavigationChild {
  name: string;
  href: string;
  disabled?: boolean; // Optional class for additional styling
  tabType?: '_blank' | '_self';
}

export interface NavigationItem {
  name: string;
  href: string;
  icon?: ForwardRefExoticComponent<React.SVGProps<SVGSVGElement>>;
  children?: NavigationChild[];
  disabled?: boolean;
  tabType?: '_blank' | '_self';
}

const navigation: NavigationItem[] = [
  { name: 'Dashboard', href: ROUTE_PATHS.DASHBOARD, icon: LayoutDashboard },
  {
    name: 'Daily Roster',
    href: '/daily-roster',
    icon: Calendar,
    disabled: true,
    tabType: '_blank'
  },
  {
    name: 'Transport Roster',
    href: '/transport-roster',
    icon: Truck,
    disabled: true,
    tabType: '_blank'
  },
  {
    name: 'Lesson Entry',
    href: '/lesson-entry',
    icon: BookOpen,
    disabled: true,
    tabType: '_blank'
  },
  {
    name: 'Report Manager',
    href: '/report-manager',
    icon: FileText,
    children: [
      {
        name: 'Instructor Report',
        href: '/report-manager/instructor-report',
        tabType: '_blank'
      },
      {
        name: 'Financial Report',
        href: '/report-manager/financial-report',
        tabType: '_blank'
      },
      {
        name: 'Hotel/Agents Report',
        href: '/report-manager/hotel-agents-report',
        tabType: '_blank'
      },
      {
        name: 'Mountain Financial Report',
        href: '/report-manager/mountain-financial-report',
        tabType: '_blank'
      },
      {
        name: 'Mountain Participant Party',
        href: '/report-manager/mountain-participant-party',
        tabType: '_blank'
      },
      {
        name: 'Group Lesson Report',
        href: '/report-manager/group-lesson-report',
        tabType: '_blank'
      },
      {
        name: 'Transport Pax Report',
        href: '/report-manager/transport-pax-report',
        tabType: '_blank'
      },
      {
        name: 'Staff Report',
        href: '/report-manager/staff-report',
        tabType: '_blank'
      }
    ]
  },
  {
    name: 'Hotel/Agent Manager',
    href: '/hotel-agent-manager',
    icon: Building,
    children: [
      {
        name: 'All Hotel/Agent',
        href: '/hotel-agent-manager',
        tabType: '_blank'
      },
      {
        name: 'Add Hotel/Agent',
        href: '/hotel-agent-manager/add',
        tabType: '_blank'
      },
      {
        name: 'Manage Commission Rate',
        href: '/hotel-agent-manager/commission-rate',
        tabType: '_blank'
      }
    ]
  },
  {
    name: 'Booking Manager',
    href: '/booking-manager',
    icon: Calendar,
    children: [
      {
        name: 'All Bookings',
        href: '/booking-manager',
        tabType: '_blank'
      },
      {
        name: 'Booking Users',
        href: '/booking-manager/booking-users',
        tabType: '_blank'
      },
      {
        name: 'Broadcast Manager',
        href: '/booking-manager/broadcast-manager',
        tabType: '_blank'
      }
    ]
  },
  {
    name: 'Instructor Manager',
    href: '/instructor-manager',
    icon: GraduationCap,
    children: [
      {
        name: 'List Instructors',
        href: '/instructor-manager',
        tabType: '_blank'
      },
      {
        name: 'Add Instructor',
        href: '/instructor-manager/add',
        tabType: '_blank'
      },
      {
        name: 'Instructor Pay Rate',
        href: '/instructor-manager/pay-rate',
        tabType: '_blank'
      }
    ]
  },
  {
    name: 'Staff Manager',
    href: '/staff-manager',
    icon: User,
    children: [
      {
        name: 'List Staff',
        href: '/staff-manager',
        tabType: '_blank'
      },
      {
        name: 'Add Staff',
        href: '/staff-manager/add',
        tabType: '_blank'
      }
    ]
  },
  {
    name: 'Service Manager',
    href: '/service-manager',
    icon: Wrench,
    children: [
      {
        name: 'All Services',
        href: '/service-manager',
        tabType: '_blank'
      },
      {
        name: 'Add Services',
        href: '/service-manager/add',
        tabType: '_blank'
      }
    ]
  },
  {
    name: 'Mountain Manager',
    href: '/mountain-manager',
    icon: Mountain,
    children: [
      {
        name: 'All Mountains',
        href: '/mountain-manager',
        tabType: '_blank'
      },
      {
        name: 'Add Mountain',
        href: '/mountain-manager/add',
        tabType: '_blank'
      }
    ]
  },
  {
    name: 'Transport Manager',
    href: '/transport-manager',
    icon: Truck,
    children: [
      { name: 'All Cars', href: '/transport-manager', tabType: '_blank' },
      {
        name: 'Add Car',
        href: '/transport-manager/add',
        tabType: '_blank'
      }
    ]
  },
  {
    name: 'Admin Users Manager',
    href: ROUTE_PATHS.ADMIN_USERS_MANAGER_LIST,
    icon: Users,
    children: [
      {
        name: 'List Users',
        href: ROUTE_PATHS.ADMIN_USERS_MANAGER_LIST,
        tabType: '_blank'
      },
      {
        name: 'Add User',
        href: ROUTE_PATHS.ADMIN_USERS_MANAGER_ADD,
        tabType: '_blank'
      }
    ]
  },
  {
    name: 'Cheat Sheet List',
    href: '/cheat-sheet-list',
    icon: List,
    tabType: '_blank'
  },
  {
    name: 'Diet Manager',
    href: '/diet-manager',
    icon: UtensilsCrossed,
    children: [
      { name: 'Diet List', href: '/diet-manager/list', tabType: '_blank' },
      { name: 'Add Diet', href: '/diet-manager/add', tabType: '_blank' }
    ]
  },
  {
    name: 'Profile',
    href: '/edit-profile', // Use first child route as default to avoid conflict with Dashboard
    icon: User2,
    children: [
      { name: 'Edit Profile', href: '/edit-profile' },
      { name: 'Change Password', href: '/change-password' },
      { name: 'Configuration', href: '/configuration' }
    ]
  }
];

export default navigation;
